"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var base_carousel_module_scss_1 = __importDefault(require("./base-carousel.module.scss"));
var CarouselPips_1 = __importDefault(require("./carousel-pips/CarouselPips"));
var CarouselNavigationButtons_1 = __importDefault(require("./carousel-navigation-buttons/CarouselNavigationButtons"));
var CarouselList_1 = __importDefault(require("./carousel-list/CarouselList"));
var utilities_1 = require("../utilities");
var DEBOUNCE_TIME = 150;
var PIXELS_FOR_PEEK = 50;
var ALPHA_BaseCarousel = function (_a) {
    var _b;
    var children = _a.children, _c = _a.showPips, showPips = _c === void 0 ? false : _c, _d = _a.showVisibleScrollbar, showVisibleScrollbar = _d === void 0 ? false : _d, numberOfItemsToShow = _a.numberOfItemsToShow, _e = _a.showNavigationButtons, showNavigationButtons = _e === void 0 ? false : _e, _f = _a.showPeek, showPeek = _f === void 0 ? false : _f, ariaLabel = _a.ariaLabel, heading = _a.heading, onResize = _a.onResize, id = _a.id, _g = _a.hasPadding, hasPadding = _g === void 0 ? false : _g;
    // Items received to show in the carousel.
    var items = react_1.default.Children.toArray(children);
    // Number of pages to show those items on.
    var numberOfPages = Math.ceil(items.length / numberOfItemsToShow);
    // Reference of the Carousel's <ul> element.
    //* Reference for the Carousels scroller/wrap element.
    var ulContainerElement = (0, react_1.useRef)(null);
    // Let's get the index of where we are in the carousel.
    //! BETA: review and refactor the manner in which React keeps track of state of the Carousel (https://www.jlpit.com/jira/browse/DSYS-1260).
    var _h = (0, react_1.useState)(0), currentIdx = _h[0], setCurrentIdx = _h[1];
    // Empty list, offsets allowed for particular pages
    var pageOffsetsRef = (0, react_1.useRef)([]);
    // Width of each item in the Carousel //* Used in resizing.
    var itemWidthRef = (0, react_1.useRef)(null);
    // Ref for the offset (width) on the x-axis from the initial content item to the second (the minimum).
    //* Used in resizing.
    var minOffsetXRef = (0, react_1.useRef)(0);
    // Peek shown in the UI to the left and right when further pages/items available (pixels)
    //! BETA: review whether peek needed, as CSS Flex is now setting this (it's either on or not). To review with design (https://www.jlpit.com/jira/browse/DSYS-1264).
    var peek = showPeek ? PIXELS_FOR_PEEK : 0;
    // Gap between an item
    //! This not needed any longer.
    // const margin = GAP_BETWEEN_ITEMS;
    // Root Margin for Intersection Observer
    //! We need to check if this is needed really... possible not?
    // const rootMargin = peek + margin;
    //* Pips.
    // Used by pips to ensure we can show the user they have clicked a pip and that we can tell when we have completed scroll.
    var _j = (0, react_1.useState)(0), pipIdx = _j[0], setPipIdx = _j[1];
    // Used with pips to ensure we can tell when we have completed scroll.
    var _k = (0, react_1.useState)(false), pipClicked = _k[0], setPipClicked = _k[1];
    // The newer way we'll be tracking state of page being watched.
    var _l = (0, react_1.useState)(0), currentPage = _l[0], setCurrentPage = _l[1];
    // Manages changes in the viewport size.
    (0, react_1.useEffect)(function () {
        var updateCarouselDimensions = function () {
            itemWidthRef.current =
                (ulContainerElement.current.offsetWidth - peek) / numberOfItemsToShow;
            var sliderWidth = ulContainerElement.current.scrollWidth;
            minOffsetXRef.current =
                ulContainerElement.current.offsetWidth - sliderWidth;
            pageOffsetsRef.current = Array.from({ length: numberOfPages }, function (_, index) {
                var pageOffset = -1 * index * numberOfItemsToShow * itemWidthRef.current;
                return Math.max(pageOffset, Math.ceil(minOffsetXRef.current));
            });
        };
        var handleWindowResize = (0, utilities_1.debounce)(function () {
            updateCarouselDimensions();
            onResize();
        }, DEBOUNCE_TIME);
        // Update the carousel dimensions on mount
        updateCarouselDimensions();
        // Add event listener for resize
        window.addEventListener('resize', handleWindowResize.debounceHandler);
        // Cleanup: remove event listener on component unmount
        return function () {
            window.removeEventListener('resize', handleWindowResize.debounceHandler);
            handleWindowResize.cancel();
        };
    }, [numberOfItemsToShow, numberOfPages, peek, onResize]);
    //* Intersection Observer
    (0, react_1.useEffect)(function () {
        var carouselScroller = ulContainerElement.current;
        var observer = new IntersectionObserver(function (observations) {
            for (var _i = 0, observations_1 = observations; _i < observations_1.length; _i++) {
                var observation = observations_1[_i];
                observation.target.classList.toggle('--in-view', observation.isIntersecting);
                if (observation.isIntersecting) {
                    var currentPageId = +observation.target.getAttribute('data-pageid');
                    if (currentPageId === numberOfPages - 1) {
                        var previousPage = observation.target.previousElementSibling;
                        previousPage.classList.remove('--in-view');
                    }
                    setCurrentPage(+observation.target.getAttribute('data-pageid'));
                }
            }
        }, {
            root: carouselScroller,
            threshold: 0.8,
            rootMargin: "0% -1% 0% -1%",
        });
        Array.from(carouselScroller.children).forEach(function (item) {
            observer.observe(item);
        });
        return function () {
            observer.unobserve(carouselScroller);
        };
    }, [numberOfPages]);
    (0, react_1.useEffect)(function () {
        if (pipClicked) {
            if (currentIdx === pipIdx) {
                setPipClicked(false);
            }
        }
    }, [currentIdx, pipIdx, pipClicked]);
    var pipOnClick = function (pipIdx) {
        setPipClicked(true);
        setPipIdx(pipIdx);
        pipClickScroll(pipIdx);
    };
    var pipClickScroll = function (pipIdx) {
        var scrollToNumber = pageOffsetsRef.current[pipIdx];
        ulContainerElement.current.scrollTo({
            left: -scrollToNumber,
            behavior: 'smooth',
        });
    };
    // This is for accessibility and ensures the carousel next/prev buttons are updated
    // as required
    var handleKeyUp = function (pageNumber) {
        updateCurrentIndex(pageNumber);
    };
    var updateCurrentIndex = function (pageNumber) {
        if (isValidPageNumber(pageNumber) && pageNumber !== currentIdx) {
            setCurrentIdx(pageNumber);
        }
    };
    var isValidPageNumber = function (pageNumber) {
        return !isNaN(pageNumber);
    };
    //! BETA: 206-247 - review as part of refactor of scroll system (https://www.jlpit.com/jira/browse/DSYS-1265).
    var goToPage = function (scrollport, element) {
        var delta = Math.abs(scrollport.offsetLeft - element.offsetLeft);
        var scrollerPadding = 0;
        var position = scrollport.clientWidth / 2 > delta
            ? delta - scrollerPadding
            : delta + scrollerPadding;
        scrollport.scrollTo({ left: position, behavior: 'smooth' });
    };
    var goNext = function () {
        var current = ulContainerElement.current.querySelectorAll('.--in-view');
        var next = current[0].nextElementSibling;
        if (next) {
            goToPage(ulContainerElement.current, next);
        }
    };
    var goPrevious = function () {
        var current = ulContainerElement.current.querySelectorAll('.--in-view');
        var next = current[0].previousElementSibling;
        if (next) {
            goToPage(ulContainerElement.current, next);
        }
    };
    var goToNextDirection = function (dir) {
        if (dir === 'right') {
            goNext();
        }
        else if (dir === 'left') {
            goPrevious();
        }
    };
    return (react_1.default.createElement("section", { "aria-label": ariaLabel, "aria-roledescription": "Carousel" },
        react_1.default.createElement("div", { className: (0, classnames_1.default)(base_carousel_module_scss_1.default['c-carousel']) },
            react_1.default.createElement("div", { className: (0, classnames_1.default)(base_carousel_module_scss_1.default['carousel-header-container'], (_b = {},
                    _b[base_carousel_module_scss_1.default['heading']] = heading,
                    _b)) },
                heading && react_1.default.createElement("h2", null, heading),
                showNavigationButtons && (react_1.default.createElement(CarouselNavigationButtons_1.default, { goToNextDirection: goToNextDirection, currentIdx: currentIdx, currentPage: currentPage, numberOfPages: numberOfPages }))),
            react_1.default.createElement(CarouselList_1.default, { id: id, showVisibleScrollbar: showVisibleScrollbar, ulContainerElementRef: ulContainerElement, handleKeyUp: handleKeyUp, items: items, numberOfItemsToShow: numberOfItemsToShow, showPeek: showPeek, hasPadding: hasPadding })),
        showPips && (react_1.default.createElement(CarouselPips_1.default, { onClick: pipOnClick, numberOfPages: numberOfPages, currentPage: currentPage }))));
};
exports.default = ALPHA_BaseCarousel;
//# sourceMappingURL=BaseCarousel.js.map